import { render } from "./TextInputSmall.vue?vue&type=template&id=1972cd3b&ts=true"
import script from "./TextInputSmall.vue?vue&type=script&lang=ts"
export * from "./TextInputSmall.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__